export default __webpack_public_path__ + "static/media/DSC06123.5baf5607.jpg";